import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-53ddb3bb.js';
var justifyMap = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  between: 'space-between',
  around: 'space-around',
  evenly: 'space-evenly',
  left: 'left',
  right: 'right'
};
var alignmentMap = {
  stretch: 'stretch',
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  baseline: 'baseline'
};

var getRem = function getRem(value) {
  var rootValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return "".concat(value / rootValue, "rem");
};

var getSpacing = function getSpacing(alias, theme) {
  var _alias$split = alias.split('-'),
      _alias$split2 = _slicedToArray(_alias$split, 2),
      key = _alias$split2[0],
      index = _alias$split2[1];

  var propID = key.charAt(0);
  var prop = propID === 'm' ? 'margin' : 'padding';
  var root = theme.rootVal;
  var value = theme.space[index];

  switch (key) {
    case "".concat(propID):
      return "".concat(prop, ": ").concat(getRem(value, root), ";");

    case "".concat(propID, "x"):
      return "\n        ".concat(prop, "-right: ").concat(getRem(value, root), ";\n        ").concat(prop, "-left: ").concat(getRem(value, root), ";\n      ");

    case "".concat(propID, "y"):
      return "\n        ".concat(prop, "-top: ").concat(getRem(value, root), ";\n        ").concat(prop, "-bottom: ").concat(getRem(value, root), ";\n      ");

    case "".concat(propID, "t"):
      return "".concat(prop, "-top: ").concat(getRem(value, root), ";");

    case "".concat(propID, "r"):
      return "".concat(prop, "-right: ").concat(getRem(value, root), ";");

    case "".concat(propID, "b"):
      return "".concat(prop, "-bottom: ").concat(getRem(value, root), ";");

    case "".concat(propID, "l"):
      return "".concat(prop, "-left: ").concat(getRem(value, root), ";");

    default:
      return null;
  }
};

var getPadding = function getPadding(alias, theme) {
  return getSpacing(alias, theme);
};

var getMargin = function getMargin(alias, theme) {
  return getSpacing(alias, theme);
};

var alignItems = function alignItems(align) {
  return "align-items: ".concat(alignmentMap[align], ";");
};

var alignContent = function alignContent(align) {
  return "align-content: ".concat(alignmentMap[align], ";");
};

var justifyContent = function justifyContent(justify) {
  return "justify-content: ".concat(justifyMap[justify], ";");
};

var getBorder = function getBorder(alias, theme) {
  var _alias$split3 = alias.split('-'),
      _alias$split4 = _slicedToArray(_alias$split3, 2),
      key = _alias$split4[0],
      index = _alias$split4[1];

  switch (key) {
    case 'b':
      return "border: ".concat(theme.borders[index]);

    case 'bx':
      return "\n        border-right: ".concat(theme.borders[index], ";\n        border-left: ").concat(theme.borders[index], ";\n      ");

    case 'by':
      return "\n        border-top: ".concat(theme.borders[index], ";\n        border-bottom: ").concat(theme.borders[index], ";\n      ");

    case 'bt':
      return "border-top: ".concat(theme.borders[index], ";");

    case 'br':
      return "border-right: ".concat(theme.borders[index], ";");

    case 'bb':
      return "border-bottom: ".concat(theme.borders[index], ";");

    case 'bl':
      return "border-left: ".concat(theme.borders[index], ";");

    default:
      return null;
  }
};

export { getPadding as a, getMargin as b, getSpacing as c, alignItems as d, alignContent as e, getBorder as f, getRem as g, justifyContent as j };